import React from 'react';
import ArrowIcon from '../ArrowIcon/ArrowIcon';
import './Button.css';

const Button = ({
  children,
  variant = 'primary',
  size = 'md',
  showArrow = false,
  onClick,
  className = '',
  type = 'button',
  disabled = false,
}) => {
  return (
    <button 
      className={`btn btn-${variant} btn-${size} ${className}`}
      onClick={onClick}
      type={type}
      disabled={disabled}
    >
      {children}
      {showArrow && (
        <span className="btn-icon">
          <ArrowIcon direction="upRight" size={18} />
        </span>
      )}
    </button>
  );
};

export default Button;

